import React, { Suspense, useRef } from "react";
import { useLocation } from "react-router-dom";
import { resolvePage } from "./registry";
import { useWikiData } from "@/providers/WikiDataProvider";
import DataError from "@/components/DataError";
import WikiNavBar from "./WikiNavBar";

const PageLoading = () => (
  <div className="flex min-h-screen items-center justify-center">
    <p className="text-[14px] text-[#999]">加载中...</p>
  </div>
);

const PageNotFound = ({ pathname }: { pathname: string }) => (
  <div className="flex min-h-screen flex-col items-center justify-center px-[24px] text-center">
    <p className="text-[18px] font-[700] leading-[25px] text-[#222]">页面未生成</p>
    <p className="mt-[8px] text-[14px] leading-[20px] text-[#999]">{pathname}</p>
  </div>
);

const GeneratedPageHost: React.FC = () => {
  const location = useLocation();
  const result = resolvePage(location.pathname);
  const dataKeys = result?.config.dataKeys ?? [];
  const { data, isLoading, error } = useWikiData(dataKeys);
  const hasLoadedOnce = useRef(false);

  if (!result) {
    return <PageNotFound pathname={location.pathname} />;
  }

  if (data) {
    hasLoadedOnce.current = true;
  }

  // Only show full-page loading on initial visit; navigations show new page immediately
  if (isLoading && !hasLoadedOnce.current) {
    return <PageLoading />;
  }

  if (error && !hasLoadedOnce.current) {
    return <DataError message={error.message} />;
  }

  const { config, params } = result;
  const PageComponent = config.Component;

  return (
    <>
      <WikiNavBar />
      <Suspense fallback={<PageLoading />}>
        <PageComponent data={data} params={params} />
      </Suspense>
    </>
  );
};

export default GeneratedPageHost;
